/* eslint-disable no-else-return */
/* eslint-disable consistent-return */
/* eslint-disable no-underscore-dangle */
/* eslint-disable no-param-reassign */
/* eslint-disable class-methods-use-this */
/* eslint-disable no-restricted-syntax */
import axios from "axios";

import { eventEmitter } from "../utils/eventEmitter";
import { storageService } from "./storageService";

// const baseUrl = 'https://mighty-forest-18459.herokuapp.com';
const baseUrl = process.env.REACT_APP_HOST_BACKEND;
// const baseUrl = 'http://127.0.0.1:3333/api/v1';

class Api {
  constructor() {
    this.jwt = "";
  }

  setJwt(jwt) {
    this.jwt = jwt;
    localStorage.setItem("jwt", jwt);
  }

  async get(
    url,
    params = {},
    requestHeaders = {},
    rawResponse = false,
    removingParameter = false
  ) {
    let _p = "";
    if (params) {
      _p = this.serialize(params);
    }

    const headers = this.headers(requestHeaders);
    const response = await fetch(
      removingParameter ? `${baseUrl}/${url}${_p}` : `${baseUrl}/${url}?${_p}`,
      {
        headers,
      }
    ).then(async (res) => {
      if (
        res.status.toString()[0] === "4" ||
        res.status.toString()[0] === "5"
      ) {
        if (res.status.toString() === "420") {
          let tokenTry =
            localStorage.getItem("@SacRPE:refreshTokenRetry") || 0;
          if (tokenTry > 3) {
            localStorage.removeItem("@SacRPE:refreshTokenRetry");
            throw new Error("Ocorreu um problema ao renovar o token");
          }

          await this.refreshToken();
          tokenTry += 1;
          localStorage.setItem("@SacRPE:refreshTokenRetry", tokenTry);
          return this.get(url, params);
        } else if (res.status.toString() === "555") {
          this.logout();
          throw new Error("Sessão Expirada");
        } else if (res.status.toString() === "406") {
          this.logout();
          throw new Error("IP inválido");
        } else if (res.status.toString() === "405") {
          this.logout(true);
          throw new Error("Sessão inválida");
        } else {
          const message = await res.json();
          throw new Error(message.message);
        }
      }

      return rawResponse ? res : res.json();
    });
    return response;
  }

  async postLogin(url, params, isFormData, responseType = "json") {
    const body = params || {};
    const headers = this.headers({});

    if (isFormData) delete headers["Content-Type"];

    try {
      const config = {
        method: "POST",
        url: `${baseUrl}/${url}`,
        headers,
        data: isFormData ? body : body,
        responseType,
      };

      const res = await axios(config);

      return res.data;
    } catch (error) {
      if (error.response) {
        if (
          error.response.status.toString()[0] === "4" ||
          error.response.status.toString()[0] === "5"
        ) {
          if (error.response.status === 403) {
            if (error.response.data.wrongAttemps >= 0) {
              throw new Error(error.response.data.message);
            }
            throw new Error("Operação proibida para esse usuário");
          } else if (error.response.status === 420) {
            await this.refreshToken();
            return this.post(url, params, isFormData, responseType);
          } else if (error.response.status === 555) {
            this.logout();
            throw new Error("Sessão Expirada");
          } else if (error.response.status === 405) {
            this.logout(true);
            throw new Error("Sessão inválida");
          } else if (error.response.status === 401) {
            if (url !== "login") this.logout();
            if (error.response.data.wrongAttemps >= 0) {
              throw new Error(error.response.data.message);
            }
            throw new Error("IP inválido");
          } else {
            throw new Error(error.response.data.message || "Erro desconhecido");
          }
        }
      } else if (error.request) {
        throw new Error("Erro na requisição");
      } else {
        throw new Error(error.message || "Erro desconhecido");
      }
    }
  }

  async post(url, params, isFormData, responseType = "json") {
    let body = {};
    if (params) body = params;
    const headers = this.headers({});
    if (isFormData) delete headers["Content-Type"];
    return fetch(`${baseUrl}/${url}`, {
      method: "POST",
      headers,
      body: isFormData ? body : JSON.stringify(body),
    }).then(async (res) => {
      if (
        res.status.toString()[0] === "4" ||
        res.status.toString()[0] === "5"
      ) {
        if (res.status.toString() === "403")
          throw new Error("Operação proibida para esse usuário");
        if (res.status.toString() === "420") {
          await this.refreshToken();
          return this.post(url, params);
        } else if (res.status.toString() === "410") {
          throw new Error("Sessão Expirada");
        } else if (res.status.toString() === "555") {
          this.logout();
          throw new Error("Sessão Expirada");
        } else if (res.status.toString() === "405") {
          this.logout(true);
          throw new Error("Sessão inválida");
        } else if (res.status.toString() === "401") {
          if (url !== "login") this.logout();
          throw new Error("IP inválido");
        } else {
          const error = await res.json();
          // Erros customizados internos retornam o statusCode
          if (error.statusCode) {
            return error;
          }
          throw new Error(error.message);
        }
      }
      if (responseType === "blob") {
        return res.blob();
      } else {
        return res.json();
      }
    });
  }

  async patch(url, params) {
    let body = {};
    if (params) body = params;
    const headers = this.headers({});
    return fetch(`${baseUrl}/${url}`, {
      method: "PATCH",
      headers,
      body: JSON.stringify(body),
    }).then(async (res) => {
      if (
        res.status.toString()[0] === "4" ||
        res.status.toString()[0] === "5"
      ) {
        if (res.status.toString() === "403")
          throw new Error("Operação proibida para esse usuário");
        if (res.status.toString() === "420") {
          await this.refreshToken();
          return this.patch(url, params);
        } else if (res.status.toString() === "555") {
          this.logout();
          throw new Error("Sessão Expirada");
        } else if (res.status.toString() === "406") {
          this.logout();
          throw new Error("IP inválido");
        } else if (res.status.toString() === "405") {
          this.logout(true);
          throw new Error("Sessão inválida");
        } else {
          const error = await res.json();
          // Erros customizados internos retornam o statusCode
          if (error.statusCode) {
            return error;
          }
          throw new Error(error.message);
        }
      }
      return res.json();
    });
  }

  async put(url, params) {
    let body = {};
    if (params) body = params;
    const headers = this.headers({});
    return fetch(`${baseUrl}/${url}`, {
      method: "PUT",
      headers,
      body: JSON.stringify(body),
    }).then(async (res) => {
      if (
        res.status.toString()[0] === "4" ||
        res.status.toString()[0] === "5"
      ) {
        if (res.status.toString() === "403")
          throw new Error("Operação proibida para esse usuário");
        if (res.status.toString() === "420") {
          await this.refreshToken();
          return this.put(url, params);
        } else if (res.status.toString() === "555") {
          this.logout();
          throw new Error("Sessão Expirada");
        } else if (res.status.toString() === "406") {
          this.logout();
          throw new Error("IP inválido");
        } else if (res.status.toString() === "405") {
          this.logout(true);
          throw new Error("Sessão inválida");
        } else {
          const error = await res.json();
          // Erros customizados internos retornam o statusCode
          if (error.statusCode) {
            return error;
          }
          throw new Error(error.message);
        }
      }
      return res.json();
    });
  }

  async delete(url, params) {
    let body = {};
    if (params) body = params;
    const headers = this.headers({});
    return fetch(`${baseUrl}/${url}`, {
      method: "DELETE",
      headers,
      body: JSON.stringify(body),
    }).then(async (res) => {
      if (
        res.status.toString()[0] === "4" ||
        res.status.toString()[0] === "5"
      ) {
        if (res.status.toString() === "403")
          throw new Error("Operação proibida para esse usuário");
        if (res.status.toString() === "420") {
          await this.refreshToken();
          return this.delete(url, params);
        } else if (res.status.toString() === "555") {
          this.logout();
          throw new Error("Sessão Expirada");
        } else if (res.status.toString() === "406") {
          this.logout();
          throw new Error("IP inválido");
        } else if (res.status.toString() === "405") {
          this.logout(true);
          throw new Error("Sessão inválida");
        } else {
          const message = await res.json();
          throw new Error(message.message);
        }
      }
      return res.json();
    });
  }

  serialize(obj) {
    const str = [];
    Object.keys(obj).forEach((key) =>
      obj[key] === undefined || obj[key] === null ? delete obj[key] : {}
    );
    for (const p in obj) {
      // eslint-disable-next-line no-prototype-builtins
      if (obj.hasOwnProperty(p)) {
        str.push(`${encodeURIComponent(p)}=${encodeURIComponent(obj[p])}`);
      }
    }
    return str.join("&");
  }

  headers(headers) {
    const jwt = storageService.getToken();
    const currentSessionId = storageService.getSessionID();
    const currentTicket = storageService.getTicketProtocol(); 

    headers = {
      ...headers,
      "Content-Type": headers["Content-Type"] || "application/json",
      Authorization: `bearer ${jwt}`,
      "X-Proccessor-Identity": storageService.getIdentity(),
      "X-Session-ID": currentSessionId,
      "X-Ticket-Protocol": currentTicket || "",
    };
    return headers;
  }

  async refreshToken() {
    const refreshToken = localStorage.getItem("@SacRPE:refreshToken");
    const body = { refreshToken };
    const res = await fetch(`${baseUrl}/reload_token`, {
      method: "POST",
      headers: this.headers({}),
      body: JSON.stringify(body),
    });
    const resJson = await res.json();
    const { token } = resJson;
    const newToken = token?.token;
    const newRefreshToken = token?.refreshToken;
    if (newToken && newRefreshToken) {
      localStorage.setItem("@SacRPE:token", newToken);
      localStorage.setItem("@SacRPE:refreshToken", newRefreshToken);
    } else {
      console.log("falha ao renovar token", resJson);
    }
  }

  async logout(isSessionExpired = false) {
    if (isSessionExpired === true) return eventEmitter.emit("logout");

    localStorage.clear();

    caches.keys().then((names) => {
      names.forEach((name) => {
        caches.delete(name);
      });
    });

    const rootURL = window.location.origin;
    window.location.replace(rootURL);
  }
}

export default new Api();

// /* eslint-disable no-else-return */
// /* eslint-disable consistent-return */
// /* eslint-disable no-underscore-dangle */
// /* eslint-disable no-param-reassign */
// /* eslint-disable class-methods-use-this */
// /* eslint-disable no-restricted-syntax */
// import axiosClient from "./axiosClient";

// import { eventEmitter } from "../utils/eventEmitter";

// class Api {
//   constructor() {
//     this.jwt = "";
//   }

//   setJwt(jwt) {
//     this.jwt = jwt;
//     localStorage.setItem("jwt", jwt);
//   }

//   async get(url, params = {}, requestHeaders = {}, rawResponse = false) {
//     const query = this.serialize(params);

//     const endpoint = query ? `/${url}?${query}` : `/${url}`;

//     const headers = this.headers(requestHeaders);

//     const res = await axiosClient.get(endpoint, {
//       headers,
//       responseType: rawResponse ? "blob" : "json",
//     });

//     return rawResponse ? res : res.data;
//   }

//   async postLogin(url, params, isFormData, responseType = "json") {
//     let headers = {
//       "Content-Type": isFormData ? undefined : "application/json",
//     };

//     if (isFormData) {
//       headers = {};
//     }

//     const res = await axiosClient.post(`/${url}`, params, {
//       headers,
//       responseType,
//       skipAuth: true,
//     });

//     return res.data;
//   }

//   async post(url, params, isFormData, responseType = "json") {
//     const headers = this.headers({});
//     if (isFormData) delete headers["Content-Type"];

//     const res = await axiosClient.post(`/${url}`, params, {
//       headers,
//       responseType,
//     });

//     return res.data;
//   }

//   async patch(url, params) {
//     const res = await axiosClient.patch(`/${url}`, params, {
//       headers: this.headers({}),
//     });

//     return res.data;
//   }

//   async put(url, params) {
//     const res = await axiosClient.put(`/${url}`, params, {
//       headers: this.headers({}),
//     });

//     return res.data;
//   }

//   async delete(url, params) {
//     const res = await axiosClient.delete(`/${url}`, {
//       headers: this.headers({}),
//       data: params,
//     });

//     return res.data;
//   }

//   serialize(obj) {
//     const str = [];

//     Object.keys(obj).forEach((key) => {
//       if (obj[key] !== undefined && obj[key] !== null) {
//         str.push(`${encodeURIComponent(key)}=${encodeURIComponent(obj[key])}`);
//       }
//     });

//     return str.join("&");
//   }

//   headers(headers) {
//     const jwt = localStorage.getItem("@SacRPE:token");
//     const sessionId = localStorage.getItem("@SacRPE:sessionId");

//     return {
//       ...headers,
//       "Content-Type": headers["Content-Type"] || "application/json",
//       Authorization: `bearer ${jwt}`,
//       "X-Proccessor-Identity": localStorage.getItem("@SacRPE:identity"),
//       "X-Session-ID": sessionId,
//     };
//   }

//   async logout(isSessionExpired = false) {
//     if (isSessionExpired) return eventEmitter.emit("logout");

//     localStorage.clear();

//     caches.keys().then((names) => {
//       names.forEach((name) => caches.delete(name));
//     });

//     window.location.replace(window.location.origin);
//   }
// }

// export default new Api();
